export default function StepperControl(props: {
  steps: {
    stepNo: number;
    name: string;
    highlighted?: boolean;
    selected?: boolean;
    completed?: boolean;
  }[];
  currentStep: number;
  handleClick: any;
}) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { steps, currentStep, handleClick } = props;
  
  return (
    <div className="mt-6 px-3 pb-4 md:px-8">
      <button
        disabled
        title="Coming Soon"
        onClick={() => handleClick("next")}
        className="w-full flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-8 py-3 font-medium text-white transition-all hover:bg-brand-600 disabled:opacity-50"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
        Send Invitation
      </button>
    </div>
  );
}
